import { useForm } from "react-hook-form";
import { useParams, Link } from "react-router-dom";
import { useStorePath } from "@hooks/useStorePath";

const BillingPage = () => {
  const { id } = useParams();
  const { storePath } = useStorePath();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    // Navigate to Payment Page
  };

  return (
    <div className="flex">
      <div className="max-w-3xl mx-auto bg-white p-6 rounded-lg">
        <h2 className="text-2xl font-semibold mb-4">Billing Details</h2>
        <p className="text-sm text-gray-600 mb-4">
          Stocko collects and uses personal data in accordance with our{" "}
          <a href="#" className="text-blue-600 underline">
            Privacy Policy
          </a>
          . By creating an account, you agree to our{" "}
          <a href="#" className="text-blue-600 underline">
            Terms and Conditions
          </a>
          .
        </p>

        <form noValidate onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          {/* First & Last Name */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                First Name<span className="text-red-500"> *</span>
              </label>
              <input
                {...register("firstName", { required: true, minLength: 2 })}
                className="w-full p-2 border rounded-md focus:ring focus:ring-blue-200"
              />
              {errors.firstName && (
                <p className="text-red-500 text-sm">Enter a valid first name.</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Last Name<span className="text-red-500"> *</span>
              </label>
              <input
                {...register("lastName", { required: true, minLength: 2 })}
                className="w-full p-2 border rounded-md focus:ring focus:ring-blue-200"
              />
              {errors.lastName && <p className="text-red-500 text-sm">Enter a valid last name.</p>}
            </div>
          </div>

          {/* Country */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Country<span className="text-red-500"> *</span>
            </label>
            <select
              {...register("country", { required: true })}
              className="w-full p-2 border rounded-md focus:ring focus:ring-blue-200"
            >
              <option value="Kenya">Kenya</option>
              <option value="Tanzania">Tanzania</option>
              <option value="Uganda">Uganda</option>
              <option value="Rwanda">Rwanda</option>
            </select>
            {errors.country && <p className="text-red-500 text-sm">Select a country.</p>}
          </div>

          {/* Address Fields */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Address line 1<span className="text-red-500"> *</span>
            </label>
            <input
              {...register("address1", { required: true, minLength: 5 })}
              className="w-full p-2 border rounded-md focus:ring focus:ring-blue-200"
            />
            {errors.address1 && <p className="text-red-500 text-sm">Enter a valid address.</p>}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">Address line 2</label>
            <input
              {...register("address2")}
              className="w-full p-2 border rounded-md focus:ring focus:ring-blue-200"
            />
          </div>

          {/* City & Zip Code */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                City<span className="text-red-500"> *</span>
              </label>
              <input
                {...register("city", { required: true, minLength: 2 })}
                className="w-full p-2 border rounded-md focus:ring focus:ring-blue-200"
              />
              {errors.city && <p className="text-red-500 text-sm">Enter a valid city.</p>}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Zip / Postal Code</label>
              <input
                {...register("zip", { minLength: 4, maxLength: 10 })}
                className="w-full p-2 border rounded-md focus:ring focus:ring-blue-200"
              />
              {errors.zip && <p className="text-red-500 text-sm">Enter a valid zip code.</p>}
            </div>
          </div>

          {/* Submit Button */}
          <div className="flex justify-end">
            <Link
              to={storePath(`payment/${id}`)}
              type="submit"
              className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition"
            >
              Continue to Payment
            </Link>
          </div>
        </form>
      </div>

      <div>
        <div className="bg-white p-5 rounded-lg w-full max-w-sm">
          <h2 className="text-lg font-semibold mb-4">Order Summary</h2>

          {/* Theme Name & Pricing */}
          <div className="flex justify-between items-center">
            <span className="text-gray-700">MetroShop Pro</span>
            <div className="text-right">
              <span className="text-gray-500 line-through">KSh 999</span>
              <span className="text-green-600 font-semibold ml-2">KSh 499</span>
            </div>
          </div>

          {/* Discounts */}
          <div className="flex justify-between text-green-600 mt-2">
            <span>Total Discounts:</span>
            <span>KSh 200</span>
          </div>

          {/* Handling Fee */}
          <div className="flex justify-between mt-2">
            <span className="flex items-center">Handling Fee:</span>
            <span>KSh 50</span>
          </div>

          {/* Total Price */}
          <div className="border-t border-gray-300 mt-3 pt-3 flex justify-between font-semibold text-lg">
            <span>Total:</span>
            <span className="text-black">KSh 549</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingPage;
